import { Component, input } from '@angular/core';
import { CopyOnHoverDirective } from '@myarvato/shared/copy';
import { DayjsPipe } from '@myarvato/shared/pipelines';
import { CommentDto } from '@myarvato/modules/transport/models';

@Component({
  selector: 'transport-comment',
  imports: [DayjsPipe, CopyOnHoverDirective],
  templateUrl: './comment.component.html',
  styleUrl: './comment.component.scss',
})
export class CommentComponent {
  // Inputs
  public readonly eventData = input.required<CommentDto>();
  public readonly side = input<'left' | 'right'>('right');
}
